import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { Collapse, Container } from "reactstrap";
import Navdata from "./LayoutMenuData";
import { Images } from "../Components/Utils/ImagePath";
import { useSelector } from "react-redux";
import { Logo } from "./Logo";

const VerticalSidebar = ({ layoutType }) => {
  const navData = Navdata().props.children;
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(null);
  const profile = useSelector((state) => state.logoHeaderView.logoHeader);
  const sidebarRef = useRef(null);
  const roleName = localStorage.getItem("roleName");
  let base64ImageData = [];
  if (roleName !== "systemUser") {
    base64ImageData = profile?.filePath || [];
  } else if (roleName === "systemUser") {
    base64ImageData = profile?.filePath || [];
  } else {
    base64ImageData = [];
  }
  const isPathActive = (path) => {
    if (!path || path === "/#") return false;
    return location.pathname === path;
  };
  const isSubItemActive = (subItems) => {
    if (!subItems) return false;
    return subItems.some((subItem) => {
      if (isPathActive(subItem.link)) return true;
      if (subItem.childItems) {
        return subItem.childItems.some((childItem) => {
          if (isPathActive(childItem.link)) return true;
          if (childItem.childItems) {
            return childItem.childItems.some((subChildItem) =>
              isPathActive(subChildItem.link),
            );
          }
          return false;
        });
      }
      return false;
    });
  };

  const closeSidebar = () => {
    document.body.classList.remove("vertical-sidebar-enable");
  };

  // Set active item based on current path
  useEffect(() => {
    const currentPath = location.pathname;
    const activeNavItem = navData.find((item) => {
      if (isPathActive(item.link)) return true;
      if (item.subItems && isSubItemActive(item.subItems)) return true;
      return false;
    });

    if (activeNavItem) {
      setActiveItem(activeNavItem.id || activeNavItem.label);
    }

    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        document.body.classList.remove("vertical-sidebar-enable"); // adjust based on your toggle class
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [location.pathname, navData]);

  return (
    <React.Fragment>
      <div className="app-menu navbar-menu" ref={sidebarRef}>
        <div className="navbar-brand-box py-2">
          <Link className="logo logo-light">
            {/* <span className="logo-sm">
                <img src={(profile?.filePath && roleName !== "systemUser") ? base64ImageData || Images.logoNewSmall : Images.logoNewSmall} alt="" height="30" />
            </span> */}
            <span className="logo-lg">
              {/* <img src={profile?.filePath && roleName !== "systemUser" ? base64ImageData || Images.logoNewBlack :roleName === "systemUser" ? base64ImageData || Images.logoNewBlack : Images.logoNewBlack} alt="" className='logo-image-lg' height="40" /> */}
              <Logo
                src={
                  (profile?.filePath && roleName !== "systemUser") ||
                  roleName === "systemUser"
                    ? base64ImageData
                    : null
                }
                height={40}
                alt="logo"
              />
            </span>
            {/* <span className="logo-lg">
              <img src={Images.logoNewBlack} alt="" height="30" />
            </span>
            <span className="logo-sm">
              <img src={Images.logoNewSmall} alt="" height="30" />
            </span> */}
          </Link>
          <button
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>

        <React.Fragment>
          <SimpleBar id="scrollbar" className="h-100">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                {(navData || []).map((item, key) => {
                  const isActive =
                    activeItem === (item.id || item.label) ||
                    isPathActive(item.link) ||
                    (item.subItems && isSubItemActive(item.subItems));

                  return (
                    <React.Fragment key={key}>
                      {item["isHeader"] ? (
                        <li className="menu-title">
                          <span data-key="t-menu">{item.label}</span>
                          <hr
                            className="my-0 mx-3"
                            style={{ borderColor: "grey" }}
                          />
                        </li>
                      ) : item.subItems ? (
                        <li className="nav-item sidebar-menu-item">
                          <Link
                            onClick={(e) => {
                              setActiveItem(item.id || item.label);
                              if (item.click) item.click(e);
                            }}
                            className={`nav-link menu-link ${isActive ? "active" : ""} ${
    item.stateVariables ? "menu-open" : ""
  }`}
                            to={item.link ? item.link : "/#"}
                            data-bs-toggle="collapse"
                          >
                            <div className="d-flex align-items-center">
                              <i className={item.icon}></i>
                              <span data-key="t-apps">{item.label}</span>
                            </div>
                          </Link>
                          <Collapse
                            className="menu-dropdown"
                            isOpen={item.stateVariables}
                            id={`sidebar-${item.id}`}
                          >
                            <ul className="nav nav-sm flex-column test">
                              {item.subItems &&
                                (item.subItems || []).map((subItem, key) => (
                                  <React.Fragment key={key}>
                                    {!subItem.isChildItem ? (
                                      <li className="nav-item">
                                        <Link
                                          to={
                                            subItem.link ? subItem.link : "/#"
                                          }
                                          className={`nav-link ms-4 ${
                                            isPathActive(subItem.link)
                                              ? "active"
                                              : ""
                                          }`}
                                          onClick={() => {
                                            setActiveItem(
                                              item.id || item.label,
                                            );
                                            closeSidebar();
                                          }}
                                        >
                                          {subItem.label}
                                          {subItem.badgeName ? (
                                            <span
                                              className={
                                                "badge badge-pill bg-" +
                                                subItem.badgeColor
                                              }
                                              data-key="t-new"
                                            >
                                              {subItem.badgeName}
                                            </span>
                                          ) : null}
                                        </Link>
                                      </li>
                                    ) : (
                                      <li className="nav-item">
                                        <Link
                                          onClick={subItem.click}
                                          className="nav-link"
                                          to="/#"
                                          data-bs-toggle="collapse"
                                        >
                                          {" "}
                                          {subItem.label}
                                        </Link>
                                        <Collapse
                                          className="menu-dropdown"
                                          isOpen={subItem.stateVariables}
                                          id="sidebarEcommerce"
                                        >
                                          <ul className="nav nav-sm flex-column">
                                            {/* child subItms  */}
                                            {subItem.childItems &&
                                              (subItem.childItems || []).map(
                                                (childItem, key) => (
                                                  <React.Fragment key={key}>
                                                    {!childItem.childItems ? (
                                                      <li className="nav-item">
                                                        <Link
                                                          to={
                                                            childItem.link
                                                              ? childItem.link
                                                              : "/#"
                                                          }
                                                          className={`nav-link ${
                                                            isPathActive(
                                                              childItem.link,
                                                            )
                                                              ? "active"
                                                              : ""
                                                          }`}
                                                          onClick={() => {
                                                            setActiveItem(
                                                              item.id ||
                                                                item.label,
                                                            );
                                                            closeSidebar();
                                                          }}
                                                        >
                                                          {childItem.label}
                                                        </Link>
                                                      </li>
                                                    ) : (
                                                      <li className="nav-item">
                                                        <Link
                                                          to="/#"
                                                          className="nav-link"
                                                          onClick={
                                                            childItem.click
                                                          }
                                                          data-bs-toggle="collapse"
                                                        >
                                                          {childItem.label}
                                                        </Link>
                                                        <Collapse
                                                          className="menu-dropdown"
                                                          isOpen={
                                                            childItem.stateVariables
                                                          }
                                                          id="sidebaremailTemplates"
                                                        >
                                                          <ul className="nav nav-sm flex-column">
                                                            {childItem.childItems.map(
                                                              (
                                                                subChildItem,
                                                                key,
                                                              ) => (
                                                                <li
                                                                  className="nav-item"
                                                                  key={key}
                                                                >
                                                                  <Link
                                                                    to={
                                                                      subChildItem.link
                                                                    }
                                                                    className={`nav-link ${
                                                                      isPathActive(
                                                                        subChildItem.link,
                                                                      )
                                                                        ? "active"
                                                                        : ""
                                                                    }`}
                                                                    data-key="t-basic-action"
                                                                    onClick={() => {
                                                                      setActiveItem(
                                                                        item.id ||
                                                                          item.label,
                                                                      );
                                                                      closeSidebar();
                                                                    }}
                                                                  >
                                                                    {
                                                                      subChildItem.label
                                                                    }
                                                                  </Link>
                                                                </li>
                                                              ),
                                                            )}
                                                          </ul>
                                                        </Collapse>
                                                      </li>
                                                    )}
                                                  </React.Fragment>
                                                ),
                                              )}
                                          </ul>
                                        </Collapse>
                                      </li>
                                    )}
                                  </React.Fragment>
                                ))}
                            </ul>
                          </Collapse>
                          <hr
                            className="my-0 mx-3"
                            style={{ borderColor: "grey" }}
                          />
                        </li>
                      ) : (
                        <li className="nav-item">
                          {item.id !== "analytics" ? (
                            <Link
                              className={`nav-link menu-link ${isActive ? "active" : ""}`}
                              to={item.link ? item.link : "/#"}
                              onClick={() => {
                                setActiveItem(item.id || item.label);
                                closeSidebar();
                              }}
                            >
                              <i className={item.icon}></i>{" "}
                              <span>{item.label}</span>
                            </Link>
                          ) : (
                            <Link
                              className={`nav-link menu-link ${isActive ? "active" : ""}`}
                              onClick={(e) => {
                                setActiveItem(item.id || item.label);
                                item.click(e);
                              }}
                            >
                              <i className={item.icon}></i>{" "}
                              <span>{item.label}</span>
                            </Link>
                          )}
                          <hr
                            className="my-0 mx-3"
                            style={{ borderColor: "grey" }}
                          />
                        </li>
                      )}
                    </React.Fragment>
                  );
                })}
              </ul>
            </Container>
          </SimpleBar>
          <div></div>
        </React.Fragment>
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default VerticalSidebar;
